import React, { Component } from "react";
import Categories from '../list/Categories';
import Criteria from '../list/Criteria';
import Definition from '../list/Definition';
import Search from '../Search';
import './index.css';

class Picker extends Component {
  constructor(props) {
    super(props);
    this.state = {
      categories: props.categories,
      currentCategoryIndex: 0,
      currentCriterionIndex: 0,
      searchKeyword: "",
      selectedCriterionInView: true
    }
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.isFilterCriterionClicked === false && nextProps.isFilterCriterionClicked === true) {
      this.updateCurrentCategoryAndCriterionIndex(nextProps.selectedResultCriterionLabel);
      this.props.selectedResultCriterionDisplayed();
    }
  }

  updateCurrentCategoryAndCriterionIndex = (selectedResultCriterionLabel) => {
    this.clearSearchKeywordHandler();
    // skip all category
    for (let categoryIndex = 1; categoryIndex < this.state.categories.length; categoryIndex++) {
      for (let criterionIndex = 0; criterionIndex < this.state.categories[categoryIndex].list.length; criterionIndex++) {
        if (this.state.categories[categoryIndex].list[criterionIndex].label === selectedResultCriterionLabel) {
          this.setState({
            currentCategoryIndex: categoryIndex,
            currentCriterionIndex: criterionIndex,
            selectedCriterionInView: false
          })
          return;
        }
      }
    }
  }

  updateSelectedCriterionInViewHandler = () => {
    this.setState({
      selectedCriterionInView: true
    })
  }

  getCurrentCategory = () => {
    return this.state.categories[this.state.currentCategoryIndex]
  }

  getCurrentCriteria= () => {
    return this.getCurrentCategory().list.filter(this.filterBySearchKeyword)
  }

  getCurrentCriterion = () => {
    return this.getCurrentCriteria()[this.state.currentCriterionIndex]
  }

  updateCurrentCategoryIndexHandler = (currentCategoryIndex) => {
    this.setState({
      currentCategoryIndex: currentCategoryIndex,
      currentCriterionIndex: 0
    })
  }

  updateCurrentCriterionIndexHandler = (currentCriterionIndex) => {
    this.setState({
      currentCriterionIndex: currentCriterionIndex
    })
  }

  updateSearchKeywordHandler = (event) => {
    this.setState({
      searchKeyword: event.target.value.toLowerCase()
    }, () => {
      const categories = this.props.categories.map(category => {
        return ({name: category.name,list: category.list.filter(this.filterBySearchKeyword)})
      });
      this.setState({
        categories: categories
      })
    })
  }

  clearSearchKeywordHandler = () => {
    const keyword = {target: {value: ''}};
    this.updateSearchKeywordHandler(keyword);
  }

  filterBySearchKeyword = (item) => {
    if (item.label.toLowerCase().indexOf(this.state.searchKeyword) >= 0) {
      return true;
    }
    return false;
  }

  render() {
    const isCriteriaEmpty = this.getCurrentCriteria() <= 0 ? true : false;

    let definitionJSX =  null;
    let criteriaStyle = {"gridTemplateColumns": "1fr"};
    if (!isCriteriaEmpty) {
      definitionJSX =
      <Definition
        definition={this.getCurrentCriterion().definition}>
      </Definition>;
      criteriaStyle = {};
    }

    return (
      <div className="AS-picker">
        <Search
          startSearch={this.updateSearchKeywordHandler}
          clearKeyword={this.clearSearchKeywordHandler}
          searchKeyword={this.state.searchKeyword}>
        </Search>
        <Categories
          clicked={this.updateCurrentCategoryIndexHandler}
          categories={this.state.categories}
          currentIndex={this.state.currentCategoryIndex}>
        </Categories>
        <div className="AS-Criteria" style={criteriaStyle}>
          <Criteria
            isEmpty={isCriteriaEmpty}
            clicked={this.props.clicked}
            mouseEntered={this.updateCurrentCriterionIndexHandler}
            criteria={this.getCurrentCriteria()}
            currentIndex={this.state.currentCriterionIndex}
            selectedCriteria={this.props.selectedCriteria}
            selectedCriterionInView={this.state.selectedCriterionInView}
            revealed={this.updateSelectedCriterionInViewHandler}>
          </Criteria>
          {definitionJSX}
        </div>
      </div>
    )
  }
}

export default Picker;



// WEBPACK FOOTER //
// ./src/views/PickerView/components/Picker/index.js